import { BaseFeatureItemDto } from '../../../shared/modules/base/dtos/base-feature-item.dto';
import { AssetFeatureItemTypeEnum } from '../enums/asset-feature-item-type.enum';

/**
 * Asset feature item DTO
 */
export class AssetFeatureItemDto extends BaseFeatureItemDto {
	type!: AssetFeatureItemTypeEnum;
}
